import { useState } from 'react';

export enum EToolActions {
  NOOP = '',
  SELECTION = 'selection',
  SELECT_AREA = 'select_area',
  UNSELECT_AREA = 'unselect_area',
}

export const useToolActionState = () => {
  const [action, setAction] = useState<EToolActions>(EToolActions.NOOP);

  return {
    action,
    onAction: setAction,
  };
};
